<input type="text" [disabled]="disabled" [ngModel]="textValue" (ngModelChange)="updateValues($event)" [class]="class">